import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Checkbox,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  Textarea,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Badge,
} from "@chakra-ui/react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  DocIcon,
  DocLargeIcon,
  DownloadIcon,
} from "../../../assets/svgs/Icons";
import { useDispatch, useSelector } from "react-redux";
import { DocumentViewer } from "../../../Components/common/DocumentViewer";
import { useParams } from "react-router";
import {
  assignToMe,
  forwardToL2TC,
  getTCDetails,
  sentBackToClient,
} from "../TCL1Approver/TCL1AdminSlice";
import moment from "moment";
import { approveTC, rejectTC } from "../TCL2Approver/TCL2AdminSlice";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import isAllowed from "../../../routing/isAllowed";
import DOCUMENT_FROM from "../../../Common/Constants";
import CustomAlertDialog from "../../../Components/CustomAlertDialog";
import SelectSearch from "react-select-search";
import { getCompanyData, getCompanyUnit, reprintTC } from "../../../api";
import { unwrapResult } from "@reduxjs/toolkit";
import { getCompanies } from "../../../redux/company/CompanySlice";
import { toast } from "react-toastify";

const TCL1Details = () => {
  const { id } = useParams();
  const [status, setStatus] = useState("idle");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { TC } = useSelector((state) => state.TCL1Admin);
  const { userData } = useSelector((state) => state.auth);
  const [comment, setComment] = useState("");
  const [isOpenMod, setIsOpenMod] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isTCReprint, setIsTCReprint] = useState(false);
  const [buyers, setBuyers] = useState([]);
  const [buyerId, setBuyerId] = useState(TC?.tc_buyer?._id);
  const [consigneeId, setConsigneeId] = useState("");
  const [consigneeUnits, setConsigneeUnits] = useState("");
  const [buyerCompany, setBuyerCompany] = useState({});
  const [consignee, setConsignee] = useState({});
  const { allCompanies } = useSelector((state) => state.company);

  const onClose = () => setIsOpen(false);
  const onCloseMod = () => setIsOpenMod(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const getBuyersData = async () => {
    let buyerOPtions = allCompanies?.data?.map((buyer) => {
      return {
        name: `${buyer?.name} (${buyer.license})`,
        value: buyer?._id,
      };
    });
    setBuyers(buyerOPtions);
  };

  const getBuyersCompany = async () => {
    const response = await getCompanyData(buyerId && buyerId);
    let buyerOPtions = response?.data?.company_units?.map((unit) => {
      return {
        name: `${unit?.name}`,
        value: unit?._id,
      };
    });
    setBuyerCompany(response?.data);
    setConsigneeUnits(buyerOPtions);
  };

  const getAllCompanies = async () => {
    let programId = TC?.tc_program?._id;

    try {
      const result = await dispatch(getCompanies({ programId }));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getBuyersCompanyUnit = async () => {
    const response = await getCompanyUnit(consigneeId);
    setConsignee(response?.data);
  };

  const handleReprintTC = async () => {
    const payload = {
      buyerId,
      consigneeId,
    };
    const response = await reprintTC(TC?._id, payload);
    if (response?.status === 200) {
      toast.success("TC Reprinted Successfully.");
      navigate(-1);
    }
  };

  const hasComments = TC?.remarks.some(
    (remark) => remark?.comment && remark.comment.length > 0
  );

  //assign to me
  const postAssignToMe = () => {
    let values = {
      comment: comment,
    };
    try {
      setStatus("pending");
      dispatch(assignToMe({ id: id, values }));
      setStatus("success");
      navigate(-1);
    } catch (error) {
      setStatus("failed");
    }
  };

  //approve tc
  const approveTCAction = (id) => {
    let values = {
      comment: comment,
    };
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(approveTC({ id: id, values }));
      setStatus("success");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setStatus("failed");
    }
  };

  //reject TC
  const rejectTCAction = (id) => {
    let values = {
      comment: comment,
    };
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(rejectTC({ id: id, values }));
      setStatus("success");
      setIsLoading(false);
    } catch (error) {
      setStatus("failed");
      setIsLoading(false);
    }
  };

  //forward to L2
  const forwardToL2Action = (id) => {
    onCloseMod();
    let values = {
      comment: comment,
    };
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(forwardToL2TC({ id: id, values }));
      setStatus("success");
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      setStatus("failed");
      setIsLoading(false);
    }
  };

  //sent back to client action
  const sentBackToClientAction = (id) => {
    onClose();
    let values = {
      comment: comment,
    };
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(sentBackToClient({ id: id, values }));
      setStatus("success");
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      setStatus("failed");
      setIsLoading(false);
    }
  };

  //get A TC
  const getTC = () => {
    try {
      setStatus("pending");
      dispatch(getTCDetails(id));
      setStatus("success");
    } catch (error) {
      setStatus("failed");
    }
  };

  useEffect(() => {
    getTC();
    getBuyersCompany();
    getBuyersData();
  }, []);

  useEffect(() => {
    getAllCompanies();
    getBuyersData();
    getBuyersCompany();
  }, [TC, buyerId]);

  useEffect(() => {
    getBuyersCompanyUnit();
  }, [consigneeId]);

  return (
    <>
      <Box marginTop="2rem">
        <Box
          display={"flex"}
          alignItems="center"
          cursor={"pointer"}
          onClick={handleGoBack}
        >
          <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
          &nbsp;
          <Text
            //#3958DC
            color={"#52BBFF"}
            fontSize={{ base: "sm", md: "sm", lg: "md" }}
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Go Back
          </Text>
        </Box>
        <Text
          mt="2rem"
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Transaction Certificate
        </Text>
      </Box>
      <Box
        marginTop={"1.5rem"}
        bg={"#52BBFF"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
      >
        TC #{TC?.tcApplicationNumber}
      </Box>
      <Box>
        <Grid templateColumns={"repeat(2,1fr)"} gap={"1rem"}>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
              h="349px"
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Buyer Details
                {TC?.buyerDetails?.name ? (
                  <Badge ml="1rem" colorScheme="red">
                    UNREGISTERED
                  </Badge>
                ) : (
                  <Badge ml="1rem" colorScheme="green">
                    REGISTERED
                  </Badge>
                )}
              </Text>
              <Box paddingLeft={"3rem"}>
                <Box>
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name
                          </Text>
                          {isTCReprint ? (
                            <SelectSearch
                              options={buyers}
                              value={buyerId}
                              search
                              onChange={(value) => {
                                setBuyerId(value);
                              }}
                            />
                          ) : (
                            <Text marginTop="10px" w="100%" fontSize={"14px"}>
                              {TC?.tc_buyer?.name || TC?.buyerDetails?.name}
                            </Text>
                          )}
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {buyerCompany?.address
                              ? buyerCompany?.address?.country
                              : TC?.tc_buyer?.address?.country ||
                                TC?.buyerDetails?.country}
                          </Text>
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                        </Text>

                        <Text marginTop="10px" w="100%" fontSize={"14px"}>
                          {buyerCompany?.address
                            ? `${buyerCompany?.address?.raw_address}, ${buyerCompany?.address?.city}, ${buyerCompany?.address?.state}, ${buyerCompany?.address?.pinCode}`
                            : TC?.tc_buyer?.address
                            ? `${TC?.tc_buyer?.address?.raw_address}, ${TC?.tc_buyer?.address?.city}, ${TC?.tc_buyer?.address?.state}, ${TC?.tc_buyer?.address?.pinCode}`
                            : TC?.buyerDetails?.address}
                        </Text>
                      </GridItem>
                    </Box>
                    <Box marginTop="35px"></Box>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
              h="349px"
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Consignee Details
              </Text>
              <Box paddingLeft={"3rem"}>
                <Box>
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {isTCReprint ? (
                              <Select
                                value={consigneeId}
                                onChange={(e) => setConsigneeId(e.target.value)}
                              >
                                <option hidden="true">
                                  Select Consignee Unit{" "}
                                </option>{" "}
                                {buyerCompany?.company_units?.map(
                                  (program, index) => (
                                    <option key={index} value={program._id}>
                                      {program?.name}
                                    </option>
                                  )
                                )}{" "}
                              </Select>
                            ) : (
                              TC?.tc_consignee?.name ||
                              TC?.consigneeDetails?.name
                            )}
                          </Text>
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {consignee?.address?.raw_address
                              ? consignee?.address?.country || "N/A"
                              : TC?.tc_consignee?.address?.country ||
                                TC?.consigneeDetails?.country}
                          </Text>
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                        </Text>

                        <Text marginTop="10px" w="100%" fontSize={"14px"}>
                          {consignee?.address?.raw_address
                            ? `${consignee?.address?.raw_address || "N/A"}, ${
                                consignee?.address?.city || "N/A"
                              }, ${consignee?.address?.state || "N/A"}, ${
                                consignee?.address?.pinCode || "N/A"
                              }`
                            : TC?.tc_consignee?.address
                            ? `${TC?.tc_consignee?.address?.raw_address}, ${TC?.tc_consignee?.address?.city}, ${TC?.tc_consignee?.address?.state}, ${TC?.tc_consignee?.address?.pinCode}`
                            : TC?.consigneeDetails?.address}
                        </Text>
                      </GridItem>
                    </Box>
                    <Box marginTop="35px"></Box>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={"1rem"}>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
              h="349px"
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Seller Details (Applicant)
              </Text>
              <Box
                border={"2px solid #2272D5"}
                width="15%"
                marginBottom={"1rem"}
                mt="1rem"
              ></Box>
              <Box paddingLeft={"3rem"}>
                <Box>
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {TC?.tc_seller?.name}
                          </Text>
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {TC?.tc_seller?.address?.country}
                          </Text>
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                        </Text>
                        <Text marginTop="10px" w="100%" fontSize={"14px"}>
                          {`${TC?.tc_seller?.address?.raw_address}, ${TC?.tc_seller?.address?.city}, ${TC?.tc_seller?.address?.state}, ${TC?.tc_seller?.address?.pinCode}`}
                        </Text>
                      </GridItem>
                    </Box>
                    <Box marginTop="35px"></Box>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
              h="349px"
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Last Processor Details
              </Text>
              <Box
                border={"2px solid #2272D5"}
                width="15%"
                marginBottom={"1rem"}
                mt="1rem"
              ></Box>
              <Box paddingLeft={"3rem"}>
                <Box>
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {TC?.tc_lastProcessor?.name}
                          </Text>
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {TC?.tc_lastProcessor?.address?.country ||
                              TC?.lastProcessorDetails?.country}
                          </Text>
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                        </Text>

                        <Text marginTop="10px" w="100%" fontSize={"14px"}>
                          {`${TC?.tc_lastProcessor?.address?.raw_address}, ${TC?.tc_lastProcessor?.address?.city}, ${TC?.tc_lastProcessor?.address?.state}, ${TC?.tc_lastProcessor?.address?.pinCode}`}
                        </Text>
                      </GridItem>
                    </Box>
                    <Box marginTop="35px"></Box>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </Box>

      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Flex
          bg="#FFFFFF"
          padding={"2rem"}
          // marginTop="2rem"
          borderRadius={"15px"}
          gap="15rem"
        >
          {/* <Box>
            <Box display={"flex"} justifyContent="space-between">
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Type of process
              </Text>
            </Box>
            {TC?.tc_processes?.map((process, index) => (
              <Flex gap="1rem" flexWrap={"wrap"}>
                <Badge key={index} fontSize="md" cursor={"pointer"} mt="1.5rem">
                  {process?.name}
                </Badge>
              </Flex>
            ))}
          </Box> */}
          <Box>
            <Box display={"flex"} justifyContent="space-between">
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Selected program
              </Text>
            </Box>
            <Badge fontSize="md" cursor={"pointer"} mt="1.5rem">
              {TC?.tc_program?.id}
            </Badge>
          </Box>
        </Flex>
      </Box>

      {/* product details */}

      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Grid templateColumns="repeat(1, 1fr)" gap="1rem">
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Box display={"flex"} justifyContent="space-between">
                <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                  <Box
                    as="span"
                    borderRight={"3px solid #2272D5"}
                    height="40px"
                    marginRight={"1rem"}
                  ></Box>
                  Product and Shipment Details
                </Text>
              </Box>

              {TC?.products.length > 0 ? (
                <>
                  <Accordion
                    mt="2rem"
                    defaultIndex={[0]}
                    allowMultiple
                    allowToggle
                  >
                    {TC?.products?.map((product, index) => (
                      <AccordionItem key={index}>
                        <h2>
                          <AccordionButton>
                            <Box as="span" flex="1" textAlign="left">
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                {product?.productId?.name ||
                                  product?.certifiedMaterial?.commodityId
                                    ?.name ||
                                  "N/A"}{" "}
                                (
                                {product?.process?.map((prc) => (
                                  <Text as="span"> {prc?.name}, </Text>
                                ))}
                                )
                              </Text>
                            </Box>
                            <AccordionIcon mt={"10px"} />
                          </AccordionButton>
                        </h2>
                        <AccordionPanel>
                          <Box key={product?._id}>
                            <Box paddingTop={"2rem"}>
                              <Grid
                                templateColumns={"repeat(5,1fr)"}
                                my={"1rem"}
                                gap="0.3rem"
                              >
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Product Name
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.productId?.name
                                      ? product?.productId?.name
                                      : "N/A"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Product Type
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.productId?.productType
                                      ? product?.productId?.productType
                                      : "N/A"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Product Category
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.productId?.product_productCategory
                                      ?.name
                                      ? product?.productId
                                          ?.product_productCategory?.name
                                      : "N/A"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Product Classification
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.productId
                                      ?.product_productClassification?.name
                                      ? product?.productId
                                          ?.product_productClassification?.name
                                      : "N/A"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Packed In
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.packedIn
                                      ? product?.packedIn
                                      : "NA"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Lot No.
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.lotNo ? product?.lotNo : "NA"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Invoice Date
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {moment(product?.invoiceDate).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Invoice No
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.invoiceNo || "N/A"}
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Net Weight
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.netWeight || 0} KG
                                  </Text>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Consumption
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.certifiedMaterial?.consumption ||
                                      0}
                                  </Text>
                                </GridItem>
                              </Grid>
                              <Grid
                                templateColumns="repeat(2,1fr)"
                                mt="1rem"
                                gap={"3rem"}
                              >
                                <GridItem>
                                  <Grid
                                    gap="1rem"
                                    templateColumns="1.5fr 1fr 0.5fr"
                                    mt="1rem"
                                  >
                                    <GridItem>
                                      <Text
                                        color={"#141D43"}
                                        fontSize="md"
                                        fontWeight={"700"}
                                        fontFamily={"font.roboto"}
                                      >
                                        Certified Material
                                      </Text>
                                      <Text
                                        marginTop="10px"
                                        w="100%"
                                        fontSize={"14px"}
                                      >
                                        {product?.certifiedMaterial?.commodityId
                                          ?.name
                                          ? product?.certifiedMaterial
                                              ?.commodityId?.name
                                          : "N/A"}
                                      </Text>
                                    </GridItem>

                                    <GridItem>
                                      <Text
                                        color={"#141D43"}
                                        fontSize="md"
                                        fontWeight={"700"}
                                        fontFamily={"font.roboto"}
                                      >
                                        Loss Percentage
                                      </Text>
                                      <Text
                                        marginTop="10px"
                                        w="100%"
                                        fontSize={"14px"}
                                      >
                                        {product?.certifiedMaterial?.lossPercent
                                          ? product.certifiedMaterial
                                              ?.lossPercent
                                          : "N/A"}
                                      </Text>
                                    </GridItem>

                                    <GridItem>
                                      <Text
                                        color={"#141D43"}
                                        fontSize="md"
                                        fontWeight={"700"}
                                        fontFamily={"font.roboto"}
                                      >
                                        Percentage
                                      </Text>
                                      <Text
                                        marginTop="10px"
                                        w="100%"
                                        fontSize={"14px"}
                                      >
                                        {product?.certifiedMaterial?.percentage
                                          ? product.certifiedMaterial
                                              ?.percentage
                                          : "N/A"}
                                      </Text>
                                    </GridItem>
                                  </Grid>

                                  <Accordion
                                    mt="2rem"
                                    defaultIndex={[0]}
                                    allowMultiple
                                    allowToggle
                                  >
                                    {product?.nonCertifiedMaterials.map(
                                      (ncp, index) => (
                                        <AccordionItem key={index}>
                                          <h2>
                                            <AccordionButton>
                                              <Box
                                                as="span"
                                                flex="1"
                                                textAlign="left"
                                              >
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.commodityId?.name
                                                    ? ncp?.commodityId?.name +
                                                      " (NON-Certified Material)"
                                                    : "NON-Certified Material Details"}
                                                </Text>
                                              </Box>
                                              <AccordionIcon />
                                            </AccordionButton>
                                          </h2>
                                          <AccordionPanel>
                                            <Grid
                                              templateColumns="repeat(5, 2fr)"
                                              mt="1rem"
                                              gap="1rem"
                                            >
                                              <GridItem>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  NON-Certified Material
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Percentage
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Consumption
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Loss Percent
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  NON-Certified Weight
                                                </Text>
                                              </GridItem>

                                              <GridItem>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.commodityId?.name
                                                    ? ncp?.commodityId?.name
                                                    : "N/A"}
                                                </Text>
                                              </GridItem>
                                              <GridItem>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.percentage
                                                    ? ncp?.percentage
                                                    : "N/A"}
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.consumption
                                                    ? ncp?.consumption
                                                    : "N/A"}
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.lossPercent
                                                    ? ncp?.lossPercent
                                                    : "N/A"}
                                                </Text>
                                              </GridItem>
                                              <GridItem ml="2rem">
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontFamily={"font.roboto"}
                                                >
                                                  {ncp?.nonCertifiedWeight
                                                    ? ncp?.nonCertifiedWeight
                                                    : "N/A"}
                                                </Text>
                                              </GridItem>
                                            </Grid>
                                          </AccordionPanel>
                                        </AccordionItem>
                                      )
                                    )}
                                  </Accordion>
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Product Information
                                  </Text>
                                  <Text
                                    marginTop="10px"
                                    w="100%"
                                    fontSize={"14px"}
                                  >
                                    {product?.productInformation
                                      ? product?.productInformation
                                      : "N/A"}
                                  </Text>
                                </GridItem>
                              </Grid>
                            </Box>
                            {/* product Input details */}

                            <Box
                              bg="#FFFFFF"
                              padding={"2rem"}
                              marginTop="1rem"
                              borderRadius={"15px"}
                            >
                              <Box
                                display={"flex"}
                                justifyContent="space-between"
                              >
                                <Text
                                  color={"#141D43"}
                                  fontSize="lg"
                                  fontWeight={"800"}
                                >
                                  <Box
                                    as="span"
                                    borderRight={"3px solid #2272D5"}
                                    height="40px"
                                    marginRight={"1rem"}
                                  ></Box>
                                  Input Details
                                </Text>
                              </Box>
                              {product?.inputs?.length > 0 ? (
                                <Accordion
                                  allowToggle
                                  mt="2rem"
                                  defaultIndex={[0]}
                                >
                                  {product?.inputs?.map((el, index) => {
                                    return (
                                      <AccordionItem key={index}>
                                        <h2>
                                          <AccordionButton>
                                            <Box flex="1" textAlign="left">
                                              {el?.heapId?.number &&
                                                `Heap Number: ${el?.heapId?.number} | `}
                                              {el?.productClassification
                                                ?.name ||
                                                el?.inventoryDetails?.id ||
                                                "N/A"}
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        <AccordionPanel pb={4}>
                                          <Grid
                                            templateColumns="repeat(6,1fr)"
                                            gap={4}
                                          >
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                                wordWrap="breakWord"
                                              >
                                                Input Item
                                              </Text>
                                            </GridItem>
                                            <GridItem maxW="180px">
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                                wordWrap="breakWord"
                                              >
                                                TC Number/Procurement Number
                                              </Text>
                                            </GridItem>
                                            <GridItem maxW="180px">
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                                wordWrap="breakWord"
                                              >
                                                Heap Number
                                              </Text>
                                            </GridItem>

                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Inventory Details
                                              </Text>
                                            </GridItem>

                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Available Quantity
                                              </Text>
                                            </GridItem>
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Consumed Quantity
                                              </Text>
                                            </GridItem>

                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.productClassification?.name
                                                  ? el?.productClassification
                                                      ?.name
                                                  : "N/A"}
                                              </Text>
                                            </GridItem>
                                            <GridItem maxW="180px">
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.tcId?.tcNumber ??
                                                  el?.procurementId?.id ??
                                                  "N/A"}
                                              </Text>
                                            </GridItem>
                                            <GridItem maxW="180px">
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.heapId?.number ??
                                                  el?.heapId?.number ??
                                                  "N/A"}
                                              </Text>
                                            </GridItem>

                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.inventoryDetails?.id
                                                  ? el?.inventoryDetails?.id
                                                  : "N/A"}
                                                (
                                                {el?.inventoryDetails?.type
                                                  ? el?.inventoryDetails?.type
                                                  : ""}
                                                )
                                              </Text>
                                            </GridItem>

                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.inventoryDetails
                                                  ?.remainingQuantity
                                                  ? el?.inventoryDetails
                                                      ?.remainingQuantity
                                                  : "N/A"}{" "}
                                                KG
                                              </Text>
                                            </GridItem>
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontFamily={"font.roboto"}
                                              >
                                                {el?.consumedQuantity
                                                  ? el?.consumedQuantity
                                                  : "N/A"}{" "}
                                                KG
                                              </Text>
                                            </GridItem>
                                          </Grid>
                                        </AccordionPanel>
                                      </AccordionItem>
                                    );
                                  })}
                                </Accordion>
                              ) : (
                                <Box
                                  display={"flex"}
                                  alignItems="center"
                                  marginTop={"1rem"}
                                  justifyContent="center"
                                >
                                  <Text
                                    fontSize={"15px"}
                                    fontWeight={"bold"}
                                    textAlign="center"
                                  >
                                    There are no input details for this product
                                  </Text>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </AccordionPanel>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </>
              ) : (
                <Text
                  color={"brand.blue"}
                  fontSize="md"
                  textAlign={"center"}
                  fontWeight={"800"}
                  mt="1rem"
                >
                  No Product Details for this application
                </Text>
              )}
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {/* input details of product above */}

      {/* total weight details */}
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          Total Weight Details
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="15%"
          marginBottom={"1rem"}
          mt="1rem"
        ></Box>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              alignItems={"flex-end"}
              gap={"3rem"}
              templateColumns="repeat(1, 1fr)"
              marginTop={"1rem"}
            >
              <Box
                display={"flex"}
                flexDirection="column"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid
                  width={"100%"}
                  templateColumns="repeat(5, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Gross Weight(kg)
                    </Text>
                    <Text marginTop="10px" w="100%" fontSize={"14px"}>
                      {TC?.totalGrossWeight}
                    </Text>
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Net Weight(kg)
                    </Text>
                    <Text marginTop="10px" w="100%" fontSize={"14px"}>
                      {TC?.totalNetWeight}
                    </Text>
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Certified Weight(kg)
                    </Text>

                    <Text marginTop="10px" w="100%" fontSize={"14px"}>
                      {TC?.totalCertifiedWeight}
                    </Text>
                  </GridItem>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box>
      {/* document section */}
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          Supporting Documents
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="15%"
          marginBottom={"1rem"}
          mt="1rem"
        ></Box>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid width={"100%"} templateColumns="repeat(4, 1fr)" gap="3rem">
              <GridItem mb="1rem">
                <Text fontSize="md" fontWeight={"800"}>
                  Invoice Document
                </Text>
              </GridItem>
              <GridItem mb="1rem">
                {" "}
                <Text fontSize="md" fontWeight={"800"}>
                  Transport Document
                </Text>
              </GridItem>
              <GridItem mb="1rem">
                {" "}
                <Text fontSize="md" fontWeight={"800"}>
                  Other Documents
                </Text>
              </GridItem>
            </Grid>
            <Grid width={"100%"} templateColumns="repeat(4, 1fr)" gap="3rem">
              {TC?.tc_invoiceDocuments.length > 0 ? (
                <DocumentViewer
                  document={TC?.tc_invoiceDocuments}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Invoice Document Found</Text>
                </Box>
              )}
              {TC?.tc_transportDocuments.length > 0 ? (
                <DocumentViewer
                  document={TC?.tc_transportDocuments}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Transport Document Found</Text>
                </Box>
              )}

              {TC?.tc_documents?.length > 0 ? (
                <DocumentViewer
                  document={TC?.tc_documents}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Other Document Found</Text>
                </Box>
              )}
            </Grid>
            <Grid
              width={"100%"}
              templateColumns="repeat(4, 1fr)"
              gap="3rem"
              ml="1rem"
            >
              {TC?.invoiceDocName ? (
                <Text>{TC?.invoiceDocName}</Text>
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Invoice Document Name</Text>
                </Box>
              )}

              {TC?.transportDocName ? (
                <Text>{TC?.transportDocName}</Text>
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Transport Document Name</Text>
                </Box>
              )}
              {TC?.documentsName ? (
                <Text>{TC?.documentsName}</Text>
              ) : (
                <Box
                  bg="#FFFFFF"
                  w={"175px"}
                  h={"125px"}
                  borderRadius={"15px"}
                  textAlign="center"
                  display="flex"
                  alignItems="center"
                  mb="1rem"
                  boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                >
                  <Text padding={"1rem"}>No Other Document Name</Text>
                </Box>
              )}
            </Grid>
          </Box>
        </Box>
      </Box>

      {/* {TC?.assignedTo === userData?._id ? (
        <Box>
          <Grid mt={"2rem"} templateColumns="repeat(4, 1fr)">
            <GridItem>
              <Textarea
                type="text"
                color={"#141D43"}
                border="none"
                width={"522px"}
                height={"164px"}
                bg={"#fff"}
                placeholder="Comments"
                fontSize={"16px"}
                borderRadius={"15px"}
                fontWeight={"400"}
                onChange={(e) => setComment(e.target.value)}
              />
            </GridItem>
          </Grid>
        </Box>
      ) : (
        ""
      )} */}

      {TC?.assignedTo === userData?._id &&
      !(TC?.status === "PENDING" && TC?.stage === "L1-TC-ISSUER") ? (
        <Box>
          <Grid mt={"2rem"} templateColumns="repeat(4, 1fr)">
            <GridItem>
              <Textarea
                type="text"
                color={"#141D43"}
                border="none"
                width={"522px"}
                height={"164px"}
                bg={"#fff"}
                placeholder="Comments"
                fontSize={"16px"}
                borderRadius={"15px"}
                fontWeight={"400"}
                onChange={(e) => setComment(e.target.value)}
              />
            </GridItem>
          </Grid>
        </Box>
      ) : (
        ""
      )}

      {TC?.status !== "PENDING" ? (
        ""
      ) : (
        <>
          <Grid
            templateColumns="repeat(1, 1fr)"
            style={{ paddingLeft: "0 !important" }}
            width={"100%"}
          >
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
              margin={"1rem"}
            >
              Remarks
            </Text>
            <GridItem
              width={"100%"}
              overflowY={"scroll"}
              className="overflow-style"
            >
              <TableContainer className="overflow-style">
                <Table
                  variant={"simple"}
                  size="md"
                  bg={"#fff"}
                  borderRadius={"15px"}
                  pr={"1rem"}
                >
                  <Thead>
                    <Tr>
                      <Th color="brand.blue" textTransform="capitalize">
                        Sr no.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Date Time
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Comment by
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Remarks
                      </Th>
                    </Tr>
                  </Thead>
                  {/* <Tbody>
                    {TC?.remarks?.length ? (
                      TC?.remarks.map((remark, index) => {
                        return (
                          <Tr>
                            <Td>{index + 1}</Td>
                            <Td>{`${moment(remark?.time).format(
                              "DD-MM-YYYY hh:mm"
                            )}`}</Td>
                            <Td>
                              {remark.userId
                                ? `${remark?.userId?.name || "N/A"} `
                                : "N/A"}
                            </Td>
                            <Td>{remark?.comment ? remark?.comment : "N/A"}</Td>
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                          No remarks for now
                        </Td>
                      </Tr>
                    )}
                  </Tbody> */}
                  <Tbody>
                    {hasComments ? (
                      TC?.remarks.map((remark, index) => {
                        const comment = remark.comment;
                        return (
                          <Tr>
                            <Td>{index + 1}</Td>
                            <Td>{`${moment(remark.time).format(
                              "DD-MM-YYYY hh:mm"
                            )}`}</Td>
                            <Td>
                              {remark.userId
                                ? `${remark.userId.name || "N/A"} `
                                : "N/A"}
                            </Td>
                            <Td>{(comment && <>{comment}</>) || "N/A"}</Td>
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                          No remarks for now
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
          </Grid>
        </>
      )}

      <Box mt={"4rem"} paddingBottom={"2rem"} marginBottom={"4rem"}>
        <ButtonGroup gap={2}>
          {(TC?.status === "INCOMING" && TC?.stage === "L2-TC-ISSUER") ||
          (TC?.status === "ASSIGNED" && TC?.stage === "L2-TC-ISSUER") ||
          (TC?.status === "PENDING" && TC?.stage === "CLIENT") ? (
            ""
          ) : (
            <>
              {TC?.status === "INCOMING" || TC?.status === "PENDING" ? (
                <Button
                  bg="#A8BF87"
                  color="#ffffFF"
                  _hover={{ bg: "#A8BF87" }}
                  w="193px"
                  h="50px"
                  disabled={isLoading ? true : false}
                  onClick={() => postAssignToMe()}
                >
                  Assign to Me
                </Button>
              ) : null}
              {TC?.status === "ASSIGNED" && (
                <>
                  {userData?._id === TC?.assignedTo ? (
                    <>
                      {isTCReprint ? (
                        <>
                          <Button
                            bg="#52BBFF"
                            color="#ffffff"
                            _hover={{ bg: "#52BBFF" }}
                            w="193px"
                            h="50px"
                            disabled={isLoading ? true : false}
                            onClick={() => handleReprintTC()}
                          >
                            Submit
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            bg="#52BBFF"
                            color="#ffffff"
                            _hover={{ bg: "#52BBFF" }}
                            w="193px"
                            h="50px"
                            disabled={isLoading ? true : false}
                            onClick={() => setIsOpenMod(true)}
                            // onClick={() => forwardToL2Action(id)}
                          >
                            Forward to L2
                          </Button>
                          <Button
                            bg="crimson"
                            color="#ffffFF"
                            _hover={{ bg: "crimson" }}
                            w="193px"
                            h="50px"
                            disabled={isLoading ? true : false}
                            onClick={() => setIsOpen(true)}
                            // onClick={() => sentBackToClientAction(id)}
                          >
                            Send to Client
                          </Button>
                          <Button
                            bg="#A8BF87"
                            color="#ffffFF"
                            _hover={{ bg: "#A8BF87" }}
                            w="193px"
                            h="50px"
                            disabled={isLoading ? true : false}
                            onClick={() => setIsTCReprint(!isTCReprint)}
                          >
                            TC Reprint
                          </Button>
                        </>
                      )}
                    </>
                  ) : (
                    <Button
                      bg="#52BBFF"
                      color="#ffffFF"
                      _hover={{ bg: "#52BBFF" }}
                      w="193px"
                      h="50px"
                      disabled={isLoading ? true : false}
                      onClick={() => postAssignToMe()}
                    >
                      Assign to Me
                    </Button>
                  )}
                </>
              )}
            </>
          )}
        </ButtonGroup>

        <CustomAlertDialog
          isOpen={isOpen}
          onClose={onClose}
          title="Are you sure?"
          content="This action cannot be undone. Do you want to continue?"
          cancelButtonText="Cancel"
          confirmButtonText="Confirm"
          cancelButtonColor="gray"
          confirmButtonColor="red"
          onConfirm={() => sentBackToClientAction(id)}
        />

        <CustomAlertDialog
          isOpen={isOpenMod}
          onClose={onCloseMod}
          title="Are you sure?"
          content="This action cannot be undone. Do you want to continue?"
          cancelButtonText="Cancel"
          confirmButtonText="Confirm"
          cancelButtonColor="gray"
          confirmButtonColor="#52BBFF"
          onConfirm={() => forwardToL2Action(id)}
        />
      </Box>
    </>
  );
};

export default isAllowed(TCL1Details);
